export class ExpiredLogin extends Error {
    constructor(message) {
        super(message);
    }
}
//# sourceMappingURL=Authentication.js.map